import React, { useEffect, useState } from 'react';

import {
  headersPlanoTrabalhoOrgInter,
  valoresExibidosPlanoTrabalhoOrgInter,
} from './auxiliarPlanoTrabalho';
import BarraInferiorBotoes from '../../../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CustomButton from '../../../../../../../components/CustomButton';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import Input from '../../../../../../../components/InputNew';
import Select from '../../../../../../../components/InputNew/Select';
import Log from '../../../../../../../components/Log/Log';
import Modal from '../../../../../../../components/Modal';
import Tabela from '../../../../../../../components/Tabela';
import UploadMultiple from '../../../../../../../components/Upload/multiple';
import WorkspaceBotoes from '../../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import httpClient, {
  isHttpError,
} from '../../../../../../../services/httpClient';
import { getPlanoTrabalhoPorOrgInter } from '../../../../../../../services/orgInters/orgInterPlanoTrabalhoService';
import { getProdutoPorComponente } from '../../../../../../../services/produtosDAF/produtosDafService';
import theme from '../../../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatarNumero,
  formatarValorFormatoDinheiro,
  formatDate,
  formatoMoney,
  parseInputMonetario,
} from '../../../../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../../../utils/swal';
import { useOrgInterDadosGerais } from '../../context/dadosGeraisContext';

interface Props {
  componente: number;
  orgInter: number;
  userID: number;
}

type PlanoTrabalhoOrgInterType = {
  id: number;
  usuarioId: number;
  orgInterId: number;
  produtoId: number;
  qtdEstimada: string;
  valorUnitario: string;
  valorFrete: string;
  taxaAdm: string;
  valorProduto: string;
  valorTotal: string;
  dataEstimativa: string;
  observacoes: string;
};

export default function PlanoTrabalhoOrgInter() {
  const { componente, orgInter, userID } = useOrgInterDadosGerais();
  const componenteLabel: Record<number, { label: string }> = {
    1: { label: 'basico' },
    2: { label: 'especializado' },
    3: { label: 'estrategico' },
  };

  //////STATES
  const [logData, setLogData] = useState<any>();
  const [showModal, setShowModal] = useState(false);
  const [planoTrabalhoOrgInterId, setPlanoTrabalhoOrgInterId] = useState('');
  const [updatingPlanoTrabalhoOrgInter, setUpdatingPlanoTrabalhoOrgInter] =
    useState(false);

  const [data, setData] = useState<any[]>();
  const [formPlanoTrabalhoOrgInter, setFormPlanoTrabalhoOrgInter] =
    useState<PlanoTrabalhoOrgInterType>({
      id: 0,
      usuarioId: userID,
      orgInterId: orgInter,
      produtoId: 0,
      qtdEstimada: '',
      valorUnitario: '',
      valorFrete: '',
      taxaAdm: '',
      valorProduto: '',
      valorTotal: '',
      dataEstimativa: '',
      observacoes: '',
    });

  //////FETCH DATA
  const [produtoData, setProdutoData] = useState<
    { value: number; label: string }[]
  >([]);
  const fetchProdutos = async () => {
    const label = componenteLabel[componente]?.label;
    if (!label) return; // evita erro

    try {
      const produtos = await getProdutoPorComponente(label);
      console.log(produtos);
      setProdutoData([
        { value: 0, label: 'Não informado' },
        ...produtos.map(
          (item: { id: number; produtofarmaceutico: string }) => ({
            value: item.id,
            label: item.produtofarmaceutico,
          }),
        ),
      ]);
    } catch (error) {
      console.error('Erro ao obter produtos:', error);
      setProdutoData([]);
    }
  };

  useEffect(() => {
    if (componente && componenteLabel[componente]) {
      fetchProdutos();
    }
  }, [componente]);

  const fetchPlanoTrabalhoOrgInter = async () => {
    try {
      const planoTrabalho = await getPlanoTrabalhoPorOrgInter(String(orgInter));
      setData(planoTrabalho);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };
  useEffect(() => {
    fetchPlanoTrabalhoOrgInter();
  }, []);

  //////TABLE E OFFCANVAS
  const tableData =
    data
      ?.slice() // faz uma cópia para não mutar o array original
      .sort(
        (a, b) =>
          new Date(a.dataInicio).getTime() - new Date(b.dataInicio).getTime(),
      )
      .map((item) => {
        return {
          id: item.id,
          produtoDAF: item.produtoDAF.produtoFarmaceutico,
          qtdEstimada: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarNumero(item.qtdEstimada)}
            </span>
          ),
          valorUnitario: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorUnitario)}
            </span>
          ),
          taxaAdm: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.taxaAdm)}
            </span>
          ),
          valorFrete: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorFrete)}
            </span>
          ),
          valorTotal: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorTotal)}
            </span>
          ),
        };
      }) || [];

  const offCanvasData =
    data?.map((item) => {
      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        produtoDAF: item.produtoDAF.produtoFarmaceutico,
        separadorItem: '',
        valorUnitario: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorUnitario)}
          </span>
        ),
        taxaAdm: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.taxaAdm)}
          </span>
        ),
        valorFrete: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorFrete)}
          </span>
        ),
        valorTotal: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorTotal)}
          </span>
        ),
        separadorObservacoes: '',
        observacoes: item.observacoes,
      };
    }) || [];

  //////FUNÇÕES HANDLE
  const handleClearForm = () => {
    setFormPlanoTrabalhoOrgInter({
      id: 0,
      usuarioId: userID,
      orgInterId: orgInter,
      produtoId: 0,
      qtdEstimada: '',
      valorUnitario: '',
      valorFrete: '',
      taxaAdm: '',
      valorProduto: '',
      valorTotal: '',
      dataEstimativa: '',
      observacoes: '',
    });
    setLogData({
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleShowModal = () => setShowModal((prev) => !prev);

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdatingPlanoTrabalhoOrgInter(false);
    handleShowModal();
  };

  const handleRowClickPlanoTrabalhoOrgInter = (id: string) => {
    setPlanoTrabalhoOrgInterId(id);
    setUpdatingPlanoTrabalhoOrgInter(true);
    setShowModal(true);

    const itemSelecionado = data?.find((d) => d.id === id);
    if (itemSelecionado) {
      const dataEstimativa = itemSelecionado.dataEstimativa
        ? new Date(itemSelecionado.dataEstimativa).toISOString().split('T')[0]
        : '';
      setFormPlanoTrabalhoOrgInter({
        id: itemSelecionado.id,
        usuarioId: userID,
        orgInterId: orgInter,
        produtoId: itemSelecionado.produtoDAF.id,
        qtdEstimada: formatarNumero(itemSelecionado.qtdEstimada),
        valorUnitario: formatarValorFormatoDinheiro(
          itemSelecionado.valorUnitario,
        ),
        valorFrete: formatarValorFormatoDinheiro(itemSelecionado.valorFrete),
        taxaAdm: formatarValorFormatoDinheiro(itemSelecionado.taxaAdm),
        valorProduto: formatarValorFormatoDinheiro(
          itemSelecionado.valorProduto,
        ),
        valorTotal:
          formatarValorFormatoDinheiro(itemSelecionado.valorTotal) || '',
        dataEstimativa: dataEstimativa,
        observacoes: itemSelecionado.observacoes || '',
      });

      setLogData({
        id: itemSelecionado.id,
        usuarioRegistro: itemSelecionado.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          itemSelecionado.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: itemSelecionado.dataRegistro,
        dataAtualizacao: itemSelecionado.dataUltimaAtualizacao,
        nEdicoes: itemSelecionado.nEdicoes,
      });
    }
  };

  //////FUNÇÕES CRUD
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    let novoValor = value;

    const camposCalculo = [
      'valorUnitario',
      'valorFrete',
      'qtdEstimada',
      'taxaAdm',
    ];

    if (camposCalculo.includes(name)) {
      // Formatar para exibição
      if (name === 'qtdEstimada') {
        novoValor = formatarNumero(value);
      } else {
        novoValor = formatoMoney(value, 2);
      }

      const frete =
        name === 'valorFrete'
          ? parseInputMonetario(value)
          : parseInputMonetario(
              formPlanoTrabalhoOrgInter.valorFrete?.toString() || '0',
            );

      const unitario =
        name === 'valorUnitario'
          ? parseInputMonetario(value)
          : parseInputMonetario(
              formPlanoTrabalhoOrgInter.valorUnitario?.toString() || '0',
            );

      const qtEstimada =
        name === 'qtdEstimada'
          ? parseFloat(value.replace(/\./g, '')) || 0
          : parseFloat(
              formPlanoTrabalhoOrgInter.qtdEstimada
                ?.toString()
                .replace(/\./g, '') || '0',
            );

      const taxaAdm =
        name === 'taxaAdm'
          ? parseInputMonetario(value) / 100 || 0
          : parseInputMonetario(
              formPlanoTrabalhoOrgInter.taxaAdm?.toString() || '0',
            ) / 100 || 0;
      let totalProduto = qtEstimada * unitario;
      totalProduto += totalProduto * taxaAdm;

      const totalProdutoFormatado = formatarValorFormatoDinheiro(totalProduto);

      setFormPlanoTrabalhoOrgInter((prev: PlanoTrabalhoOrgInterType) => ({
        ...prev,
        [name]: novoValor,

        valorProduto: totalProdutoFormatado,
        valorTotal: formatarValorFormatoDinheiro(totalProduto + frete),
      }));
      return;
    }

    setFormPlanoTrabalhoOrgInter((prev: PlanoTrabalhoOrgInterType) => ({
      ...prev,
      [name]: novoValor,
    }));
  };

  const adjustFormPlanoTrabalhoOrgInterBeforeSubmit = (
    formPlanoTrabalhoOrgInter: any,
  ) => {
    const adjustedForm = {
      ...formPlanoTrabalhoOrgInter,
      orgInterId: Number(formPlanoTrabalhoOrgInter.orgInterId),
      produtoId: Number(formPlanoTrabalhoOrgInter.produtoId),
      qtdEstimada: Number(
        formPlanoTrabalhoOrgInter.qtdEstimada.replace(/\./g, ''),
      ),
      valorFrete: Number(
        formPlanoTrabalhoOrgInter.valorFrete
          .replace(/\./g, '')
          .replace(',', '.'),
      ),
      valorUnitario: Number(
        formPlanoTrabalhoOrgInter.valorUnitario
          .replace(/\./g, '')
          .replace(',', '.'),
      ),
      taxaAdm: Number(
        formPlanoTrabalhoOrgInter.taxaAdm.replace(/\./g, '').replace(',', '.'),
      ),

      //Observações
      observacoes:
        formPlanoTrabalhoOrgInter.observacoes === ''
          ? 'Sem observações específicas.'
          : formPlanoTrabalhoOrgInter.observacoes,
    };

    // Remover campos não desejados
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { valorProduto, valorTotal, ...cleanForm } = adjustedForm;

    return cleanForm;
  };

  const validateForm = (form: any) => {
    const erros = [];
    if (!form.dataEstimativa) erros.push('<b>Data Estimada</b> é obrigatória.');
    if (form.produtoId === 0)
      erros.push('<b>Produto Farmacêutico</b> é obrigatório.');
    if (!form.qtdEstimada)
      erros.push('<b>Quantidade Estimada</b> é obrigatória.');
    if (!form.valorUnitario)
      erros.push('<b>Valor Unitário R$</b> é obrigatório.');
    if (!form.taxaAdm) erros.push('<b>Taxa Administrativa</b> é obrigatória.');
    if (!form.valorFrete) erros.push('<b>Valor do Frete</b> é obrigatório.');

    if (erros.length > 0) {
      swalAttention(erros.join('<br>'));
      return false;
    }

    return true;
  };

  const handleCreate = async () => {
    try {
      if (!validateForm(formPlanoTrabalhoOrgInter))
        throw new Error('Formulário inválido.');

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormPlanoTrabalhoOrgInterBeforeSubmit(
        formPlanoTrabalhoOrgInter,
      );
      await httpClient.post(`/api/orginter-planotrabalho`, adjustedForm);
      swalSave();
      fetchPlanoTrabalhoOrgInter();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(formPlanoTrabalhoOrgInter))
        throw new Error('Formulário inválido.');

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormPlanoTrabalhoOrgInterBeforeSubmit(
        formPlanoTrabalhoOrgInter,
      );

      const response = await httpClient.patch(
        `/api/orginter-planotrabalho/${planoTrabalhoOrgInterId}`,
        adjustedForm,
      );
      swalAtualizacao('Sucesso', response.data.message);
      fetchPlanoTrabalhoOrgInter();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await httpClient.delete(
        `/api/orginter-planotrabalho/${planoTrabalhoOrgInterId}`,
      );
      swalDeleteConfirm();
      fetchPlanoTrabalhoOrgInter();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  return (
    <BoxConteudo boxTitulo="Plano de Trabalho">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headersPlanoTrabalhoOrgInter}
            dataTable={tableData}
            displayValues={valoresExibidosPlanoTrabalhoOrgInter}
            onRowClick={handleRowClickPlanoTrabalhoOrgInter}
            dataOffCanvas={offCanvasData}
            botaoAbrirOffCanvas={false}
            showPagination={false}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            setUpdatingPlanoTrabalhoOrgInter(false);
            handleClickInserirNovo();
          }}
          disabled={isNaN(orgInter)}
        />
      </CustomCol>

      {/* Modal Fiscal /*/}
      <Modal
        tituloModal="Item do Plano de Trabalho"
        open={showModal}
        onHide={handleShowModal}
      >
        <WorkspaceFicha>
          <Log
            {...logData}
            entity="TB_ORG_INTER_PLANO_TRAB"
            id={Number(formPlanoTrabalhoOrgInter.id)}
          />
          <BoxConteudo boxTitulo="Item">
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="190px">
                <Input
                  id="dataEstimativa"
                  name="dataEstimativa"
                  type="date"
                  value={formPlanoTrabalhoOrgInter.dataEstimativa}
                  label="Data da Estimativa"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="100px">
                <Input
                  id="produtoId"
                  name="produtoId"
                  value={
                    formPlanoTrabalhoOrgInter.produtoId === 0
                      ? ''
                      : formPlanoTrabalhoOrgInter.produtoId
                  }
                  label="ID"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Select
                  name="produtoId"
                  value={formPlanoTrabalhoOrgInter.produtoId}
                  label="Produto Farmacêutico"
                  options={produtoData}
                  onChange={handleChange}
                  required
                  disabled={updatingPlanoTrabalhoOrgInter}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="190px">
                <Input
                  id="qtdEstimada"
                  name="qtdEstimada"
                  value={formPlanoTrabalhoOrgInter.qtdEstimada}
                  label="Qtd Estimada"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="170px">
                <Input
                  id="valorUnitario"
                  name="valorUnitario"
                  value={formPlanoTrabalhoOrgInter.valorUnitario}
                  label="Valor Unitário (R$)"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>

              <CustomCol
                width="150px"
                helpText="Percentual aplicado sobre o valor do produto."
              >
                <Input
                  id="taxaAdm"
                  name="taxaAdm"
                  value={formPlanoTrabalhoOrgInter.taxaAdm}
                  label="Taxa Admin. (%)"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="170px">
                <Input
                  id="valorFrete"
                  name="valorFrete"
                  value={formPlanoTrabalhoOrgInter.valorFrete}
                  label="Valor do Frete (R$)"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="270px">
                <Input
                  id="valorProduto"
                  name="valorProduto"
                  value={formPlanoTrabalhoOrgInter.valorProduto}
                  label="Valor Produto + Taxa Adm. (R$)"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>

              <CustomCol>
                <Input
                  id="valorTotal"
                  name="valorTotal"
                  value={formPlanoTrabalhoOrgInter.valorTotal}
                  label="Valor Total R$"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
            </CustomRow>

            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  value={formPlanoTrabalhoOrgInter.observacoes}
                  label="Observações"
                  linhas={5}
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
          <UploadMultiple></UploadMultiple>
          <BarraInferiorBotoes>
            {updatingPlanoTrabalhoOrgInter ? (
              <WorkspaceBotoes
                delete
                // deleteDisabled={btDisable}
                onClickDelete={handleDelete}
                save
                // saveDisabled={btDisable}
                onClickSave={handleUpdate}
              />
            ) : (
              <WorkspaceBotoes
                inserir
                inserirDisabled={isNaN(orgInter)}
                onClickInserir={handleCreate}
              />
            )}
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </Modal>
    </BoxConteudo>
  );
}
